import { createContext } from "react";


export const EmailAddress = createContext();